export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/digital-pattern.636c1b2.svg";